import { Link } from "react-router-dom";
import { TitleFooter } from "../ui/text/TitleFooter";
import { List } from "../ui/list/List";
import { footerData } from "../utils/myData";
import { ParallaxText } from "../ui/organisms/TextVelocity";
import { Container } from "../ui/atoms/Container";
import { Article } from "../ui/atoms/Article";
import { ParagraphCustom } from "../ui/atoms/ParagraphCustom";
const Footer = ({ showFooter }) => {
  return (
    <footer className={`${showFooter ? "block" : "hidden" } relative`}>
        <Article className="min-h-screen flex lg:py-52 py-32 items-stretch">
          <ParallaxText />

          <Container className="flex flex-col justify-between">
            <div className="w-full lg:h-72 min-h-96 grow py-10">
              <ul className="flex lg:flex-row flex-col items-stretch w-full h-full  gap-10">
                { footerData.map( item => 
                  <li key={item?.lists.id} className="lg:w-1/4 w-full flex flex-col gap-4">
                    <TitleFooter title={item.title} />
                    <List data={item.lists}/>
                  </li>
                )}
              </ul>
            </div>

            <div className="border-t border-slate-400 h-20 relative py-4 lg:divide-x divide-slate-700 lg:gap-0 gap-4  flex lg:flex-row flex-col lg:items-center">
              <ParagraphCustom className="text-slate-300 px-4"><sup>©</sup> 2025 Lab Mobali</ParagraphCustom>
              <ParagraphCustom className="text-slate-300 px-4"> Développé par 
                <Link to="https://www.sergelema.com/fr" target="_blank" className="underline hover:text-orange-400"
                > Serge Lema 
                </Link> 
              </ParagraphCustom>
            </div>

          </Container>
        </Article>
      
    </footer>
  );
};

export default Footer;
